'use strict';

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// https://developer.mozilla.org/en-US/docs/Web/API/element
var omitProps = {
  attributes: true,
  childElementCount: true,
  children: true,
  classList: true,
  clientHeight: true,
  clientLeft: true,
  clientTop: true,
  clientWidth: true,
  currentStyle: true,
  firstElementChild: true,
  innerHTML: true,
  lastElementChild: true,
  nextElementSibling: true,
  ongotpointercapture: true,
  onlostpointercapture: true,
  onwheel: true,
  outerHTML: true,
  previousElementSibling: true,
  runtimeStyle: true,
  scrollHeight: true,
  scrollLeft: true,
  scrollLeftMax: true,
  scrollTop: true,
  scrollTopMax: true,
  scrollWidth: true,
  tabStop: true,
  tagName: true
};

var escapes = {
  '<': '&lt;',
  '>': '&gt;',
  '&': '&amp;',
  '"': '&quot;',
  '\'': '&apos;',
  '`': '&#96;'
};

var escape = function escape(string) {
  return String(string).replace(/[&<>"'`]/g, function (char) {
    return escapes[char];
  });
};

var appendProps = exports.appendProps = function appendProps(vnodePtr) {
  var raws = window.asmDomHelpers.vnodesData[vnodePtr];
  if (raws === undefined) return '';

  raws = raws.raw;
  if (raws === undefined) return '';

  var props = '';
  // eslint-disable-next-line
  for (var key in raws) {
    var type = _typeof(raws[key]);
    if (omitProps[key] === undefined && type !== 'function' && type !== 'undefined') {
      props += ' ' + key + '="' + escape(raws[key]) + '"';
    }
  }

  return props;
};

var insertInnerHTML = exports.insertInnerHTML = function insertInnerHTML(vnodePtr) {
  var data = window.asmDomHelpers.vnodesData[vnodePtr];
  return data !== undefined && data.raw !== undefined && data.raw.innerHTML !== undefined ? String(data.raw.innerHTML) : '';
};

var toHTML = exports.toHTML = function toHTML(vnode) {
  if (typeof vnode !== 'number') return '';

  var html = window.asmDom._toHTML(vnode);

  if (window.asmDom.clearMemory === true) {
    setTimeout(window.asmDom.deleteVNode.bind(null, vnode));
  }

  return html;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/asm-dom/lib/js/toHTML.js
// module id = 6
// module chunks = 2